import axios from 'axios';
import { supabase } from '../lib/supabaseClient';

export async function savePetition(petitionData) {
  const { filepet, files, filevoucher, ...petitionDataClean } = petitionData;
  try {
    // Agregar archivos servidor SPACE
    const urlPetition = await uploadFileSpace(filepet[0], 'solicitudes');
    const urlVoucher = await uploadFileSpace(filevoucher[0], 'pagos');
    const urlAnexos = await Promise.all(
      files.map((file) => uploadFileSpace(file, 'solicitudes')),
    );

    const res = await axios.post(
      'https://dlclizvwezaxdcvsmuip.supabase.co/functions/v1/insert_process_review',
      petitionDataClean,
      {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_ANON_KEY}`,
          'Content-Type': 'application/json',
        },
      },
    );

    await insertDocument({
      request_id: res.data.process_id,
      type_document: 'petition',
      file_name: urlPetition.stored_name,
      file_url: urlPetition.file_url,
    });

    await Promise.all(
      urlAnexos.map((anexo) =>
        insertDocument({
          request_id: res.data.process_id,
          type_document: 'anexos',
          file_name: anexo.stored_name,
          file_url: anexo.file_url,
        }),
      ),
    );

    await insertPayment({
      type_bank: petitionDataClean.bank,
      invoice_ruc: petitionDataClean.rucFactura,
      invoice_email: petitionDataClean.emailFactura,
      type_document: petitionDataClean.invoice,
      file_url: urlVoucher.file_url,
      request_id: res.data.process_id,
    });

    return res.data;
  } catch (error) {
    if (error.response) {
      console.error('Error del servidor:', error.response.data);
    } else {
      console.error('Error de red:', error.message);
    }
  }
}

export async function insertDocument(data) {
  const { error } = await supabase.from('documents_request').insert(data);
  if (error) throw error;
}

export async function insertPayment(data) {
  const { error } = await supabase.from('payment_rights').insert(data);
  if (error) throw error;
}

export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(',')[1]); // remove metadata
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export async function uploadFileSpace(file, folder) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('folder', folder);

  const res = await axios.post(
    'https://dlclizvwezaxdcvsmuip.supabase.co/functions/v1/upload-space',
    formData,
    {
      headers: {
        apikey: process.env.REACT_APP_SUPABASE_API_KEY,
        Authorization: `Bearer ${process.env.REACT_APP_ANON_KEY}`,
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return res.data;
}

export async function sendEmail(email, name) {
  const response = await fetch(
    'https://www.arbitrajeccia.com.pe/sistema/api/sendEmailPetition.php',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: email,
        name: name,
      }),
    },
  );
  return response.json();
}

export const consultSunat = async (numberDocument) => {
  if (!/^\d+$/.test(numberDocument)) {
    throw new Error('El documento solo debe contener números');
  }

  if (![8, 11].includes(numberDocument.length)) {
    throw new Error('El documento debe tener 8 (DNI) u 11 (RUC) dígitos');
  }

  const isDni = numberDocument.length === 8;

  const url = isDni
    ? 'https://camara-arequipa.org.pe/api/consulta_dni.php'
    : 'https://camara-arequipa.org.pe/api/consulta_ruc.php';

  const formData = new FormData();
  formData.append('numero', numberDocument);

  const res = await fetch(url, {
    method: 'POST',
    body: formData,
  });

  if (!res.ok) {
    const error = await res.text();
    throw new Error(error || 'Error en la consulta');
  }

  const data = await res.json();
  return parseSunatResponse(data);
};

function parseSunatResponse(res) {
  const resParsed = JSON.parse(res);

  if (resParsed.message) {
    console.log(resParsed.message);
    return;
  }

  let razon = '';
  let address = '';

  if (!resParsed.razonSocial) {
    razon =
      resParsed.apellidoPaterno +
      ' ' +
      resParsed.apellidoMaterno +
      ' ' +
      resParsed.nombres;
  } else {
    razon = resParsed.razonSocial;
    address =
      resParsed.direccion +
      ' ' +
      resParsed.departamento +
      ' - ' +
      resParsed.provincia +
      ' - ' +
      resParsed.distrito;
  }

  return { razon, address };
}
